module.exports = __webpack_public_path__ + "static/gifcoloquio-4addefef8a2eb20432904c0804b0539f.gif";